export default {
  INCOMPLETE: "INCOMPLETE",
  TRIALING: "TRIALING",
  TRIAL_ENDED: "TRIAL_ENDED",
  ACTIVE: "ACTIVE",
  PAST_DUE: "PAST_DUE",
  CANCELLED: "CANCELLED",
  TEST: "TEST",
  FREE: "FREE"
};